var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "whatsapp-message-preview" }, [
    _c("div", { staticClass: "heading" }, [_vm._v("Preview")]),
    _vm._v(" "),
    _c("div", { staticClass: "content-wrapper" }, [
      _vm.headerMediaType === "DOCUMENT"
        ? _c("div", [
            _c("embed", {
              attrs: {
                src: _vm.headerMediaURL,
                width: "100%",
                type: "application/pdf",
              },
            }),
          ])
        : _vm.headerMediaType === "VIDEO"
        ? _c("div", [
            _c("video", {
              attrs: { width: "100%", src: _vm.headerMediaURL, controls: "" },
            }),
          ])
        : _vm.headerMediaType === "IMAGE"
        ? _c("div", [
            _c("img", {
              attrs: { width: "100%", src: _vm.headerMediaURL, alt: "" },
            }),
          ])
        : _c("div", { staticClass: "header-text" }, [
            _vm._v(_vm._s(_vm.headerText)),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [_vm._v(_vm._s(_vm.body))]),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [_vm._v(_vm._s(_vm.footer))]),
      _vm._v(" "),
      _c("div", { staticClass: "timestamp" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$moment().format("HH:mm")) +
            "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.buttons
      ? _c(
          "div",
          { staticClass: "buttons" },
          [
            _vm._l(_vm.buttons, function (button) {
              return [
                button.type === "URL"
                  ? _c("div", { staticClass: "button url" }, [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("open_in_new"),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(button.text) +
                          "\n            "
                      ),
                    ])
                  : _c("div", { staticClass: "button quick-reply" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(button.text) +
                          "\n            "
                      ),
                    ]),
              ]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }